var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    viewBox: "221.7 242.2 192.2 210.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF66;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.2,338.2c0-52.7-42.8-95.5-95.5-95.5s-95.5,42.8-95.5,95.5c0,0.2,0,0.3,0,0.5h0v94  c0,10.8,8.8,19.6,19.6,19.6c10.5,0,19.1-8.3,19.6-18.7c0-0.3,0-0.7,0-1c0-10.1,8.2-18.4,18.4-18.4c10.2,0,18.4,8.2,18.4,18.4  c0,0.2,0,0.5,0,0.7c0.3,10.6,8.9,19,19.6,19c10.6,0,19.3-8.5,19.6-19c0-0.2,0-0.4,0-0.6c0-10.2,8.2-18.4,18.4-18.4  c10.1,0,18.4,8.2,18.4,18.4h0c0,10.8,8.8,19.6,19.6,19.6s19.6-8.8,19.6-19.6v-94h0C413.2,338.5,413.2,338.4,413.2,338.2z   M267.4,339.9c-9.8,0-17.8-8-17.8-17.8c0-9.8,8-17.8,17.8-17.8c9.8,0,17.8,8,17.8,17.8C285.2,331.9,277.2,339.9,267.4,339.9z   M368,339.9c-9.8,0-17.8-8-17.8-17.8c0-9.8,8-17.8,17.8-17.8s17.8,8,17.8,17.8C385.8,331.9,377.9,339.9,368,339.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.800f31e6cf5c2ba75bba3859b9d2e7ac.svg";
export { ForwardRef as ReactComponent };